module.exports = __webpack_public_path__ + "img/bg2-blur.10f07fb.jpg";